import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/InstallPrompt.css';

const InstallPrompt = () => {
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    // Check if already dismissed recently
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed) {
      const dismissedAt = parseInt(dismissed, 10);
      // Show again after 7 days
      if (Date.now() - dismissedAt < 7 * 24 * 60 * 60 * 1000) return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Listen for SW updates
    const updateHandler = () => setShowUpdate(true);
    window.addEventListener('sw-updated', updateHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('sw-updated', updateHandler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowInstall(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowInstall(false);
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  const handleUpdate = () => {
    setShowUpdate(false);
    window.location.reload();
  };

  if (showUpdate) {
    return (
      <div className="install-prompt">
        <div className="install-prompt__content">
          <span className="install-prompt__text">
            {t('install.newVersion')}
          </span>
          <button className="install-prompt__btn" onClick={handleUpdate}>
            {t('install.update')}
          </button>
        </div>
      </div>
    );
  }

  if (!showInstall) return null;

  return (
    <div className="install-prompt">
      <div className="install-prompt__content">
        <img src="/icon-96x96.png" alt="Main2Main" className="install-prompt__icon" />
        <div className="install-prompt__text">
          <strong>{t('install.title')}</strong>
          <span>{t('install.description')}</span>
        </div>
        <div className="install-prompt__actions">
          <button className="install-prompt__btn" onClick={handleInstall}>
            {t('install.installButton')}
          </button>
          <button className="install-prompt__dismiss" onClick={handleDismiss}>
            {t('install.later')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
